import { useEffect } from 'react';
import { ErrorBoundary } from '@awais4123/fillify-design-library';
import { BKJToastContainer } from '@awais4123/fillify-design-library/lib/components/BKJToastMessage/BKJToastContainer';
import { AppWrapper } from './components/AppWrapper';
import { BKJMainNavigation } from './components/BKJMainNavigation';
import { GlobalLoading } from './components/GlobalLoading';
import { GlobalModals } from './components/GlobalModals';
import { TranslationSwitch } from './components/TranslationSwitch';
import { ChameleonContainer } from './containers/ChameleonContainer/ChameleonContainer';
import { GoogleAnalyticsContainer } from './containers/GoogleAnalyticsContainer';
import { MouseflowContainer } from './containers/MouseflowContainer/MouseflowContainer';
import { ServerNotReachablePage } from './pages/ServerNotReachablePage';
import { FC } from 'react';
import { Routes } from './routes';
import { useIsGlobalLoadingSelector } from './store/selectors/userSelectors/isGlobalLoadingSelector';
import { useIsJ360ApiDown } from './store/selectors/userSelectors/isJ360ApiDown';
import { withMemo } from './utils/withMemo';
import { WhiteLabelAccessor } from './utils/whiteLabelAccessor';
import { toggleZenDesk } from './utils/zenDesk';
import { useMessaging } from './hooks/useMessaging';
import { useResponsive } from './providers/ResponsiveProvider/Responsive';
import { useSelector } from 'react-redux';
import { sessionTokenSelector } from 'store/selectors/userSelectors/sessionTokenSelector';

const J360App: FC = () => {
  const { isMobile } = useResponsive();
  const sessionToken = useSelector(sessionTokenSelector);
  const { isWhiteLabelled, isPetalProvider, isWhiteLabelDemoProvider, isfillifyProvider } =
    WhiteLabelAccessor;
  const zendeskConditions = {
    condition: isMobile || isWhiteLabelDemoProvider || isPetalProvider || isfillifyProvider,
  };

  useEffect(() => {
    toggleZenDesk('hide', zendeskConditions);
    return () => toggleZenDesk('hide');
  }, [isMobile]); // eslint-disable-line

  const isLoading = useIsGlobalLoadingSelector();
  const isJ360ApiDown = useIsJ360ApiDown();
  useMessaging();
  if (isLoading) return <GlobalLoading />;
  if (isJ360ApiDown) return <ServerNotReachablePage />;
  return (
    <ErrorBoundary componentName="App" showLogo={!isWhiteLabelled()}>
      <AppWrapper $isLoggedIn={sessionToken}>
        <BKJMainNavigation />
        <Routes />
        <GlobalModals />
        <TranslationSwitch />
        <GoogleAnalyticsContainer />
        <ChameleonContainer />
        <MouseflowContainer />
        <BKJToastContainer icon={false} />
      </AppWrapper>
    </ErrorBoundary>
  );
};

export const App = withMemo(J360App);
